import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useLiquiditySelector = () => useSelector((state: TAppState) => state.liquidityReducer);
export const useAdvisorLiquiditySelector = () => useSelector((state: TAppState) => state.advisorLiquidityReducer);
